import { UUID } from "crypto";

import { useLazyGetCompanyStageOwnersQuery } from "@services/api/catalogs";

export interface AssignableOwner {
    id: UUID;
    name: string;
    last_name: string;
    last_name_2: string;
    email?: string;
}

interface LoadAssignableOwnersParams {
    companyId: UUID;
    stageId: UUID;
}

export function useAssignableOwners() {
    const [triggerGetCompanyStageOwners, { isFetching: loading }] = useLazyGetCompanyStageOwnersQuery();

    const loadAssignableOwners = async ({
        companyId,
        stageId,
    }: LoadAssignableOwnersParams): Promise<Array<AssignableOwner>> => {
        const configs = await triggerGetCompanyStageOwners(
            `q=company_id:${companyId}&q=stage_id:${stageId}&size=200`,
            true,
        ).unwrap();

        return configs.map((config) => ({
            id: config.user_bpm_id,
            name: config.user_bpm?.name ?? "",
            last_name: config.user_bpm?.last_name ?? "",
            last_name_2: config.user_bpm?.last_name_2 ?? "",
            email: config.user_bpm?.email,
        }));
    };

    return { loading, loadAssignableOwners };
}
